import React, { memo, useCallback } from "react";
import {FormBlocks} from './FormBlocks';
import {formFieldsAttributes} from '../../FormBuilderFunctions/FieldProps';
import InputMask from 'react-input-mask';

const PhoneNumber = (props)=>{
  const  {
    item,
    className,
    fieldObj,
    validationForms,
  } = props;
  

  const preventNonNumericalInput = useCallback((e) =>{
    if(props.isAllowNegative===true){
      e = e || window.event;
      let charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      let charStr = String.fromCharCode(charCode);
      
      if (!charStr.match(/^[0-9]+$/))
        e.preventDefault();
    }
  });

  //GET AND CHECK PHONE-NUMBER-FORMAT
  const userInfo = JSON.parse(localStorage.getItem('user_info')); 
  let phoneNumberFormat = userInfo.data.locale_phone_number_format;
  if(phoneNumberFormat) {
    phoneNumberFormat = phoneNumberFormat.replace(/N/g, '9');
    phoneNumberFormat = phoneNumberFormat.replace(/X/g, '*');
  } 
  
  const attr = formFieldsAttributes(
    {...item,className:className
  },validationForms,e => {});
  delete attr.fieldAttributes['maxLength'];
  return(
    <FormBlocks {...props}  attr={attr}>
        <InputMask
          mask={phoneNumberFormat} 
          maskChar="" 
          value={attr.value}
          onChange={(e)=>props.onChangeInputAction(fieldObj,e)}
          onBlur={(e)=>props.onBlurHandlerAction(fieldObj,e)}
          {...attr.fieldAttributes}
          onKeyPress={e=>preventNonNumericalInput(e)}
        />
          {/* <input 
            value={attr.value}
            type={type}
            onChange={attr.onChange}
            {...attr.fieldAttributes}
          /> */}
      </FormBlocks>
  )
};

PhoneNumber.defaultProps = {
  generator: false,
  className: "form-control",
  isAllowNegative:true
}
const isDiffProps = (prevProps,nextProps)=>{
  if(prevProps.item.selectedValue===nextProps.item.selectedValue && prevProps.validationForms===nextProps.validationForms && prevProps.item.access_mode===nextProps.item.access_mode && prevProps.item.required===nextProps.item.required){
    return true;
  }
}

export default memo(PhoneNumber,isDiffProps);
